/**var cookieValue = document.cookie.match('(^|[^;]+)\\s*' + 'xsdcxyn' + '\\s*=\\s*([^;]+)');
 var value = cookieValue ? cookieValue.pop() : '';
 var isSSOAuthorized = !!value;
 window.sprChatSettings = window.sprChatSettings || {};
 window.sprChatSettings = {
   "appId":"app_400790",
   "user": {
    "isSSOAuthorized": isSSOAuthorized,
   },
 };
 
 (function(){var t=window,e=t.sprChat,a=e&&!!e.loaded,n=document,r=function(){r.m(arguments)};r.q=[],r.m=function(t){r.q.push(t)},t.sprChat=a?e:r;var o=function(){var e=n.createElement("script");e.type="text/javascript",e.async=!0,e.id='sprChatScript',e.src="https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/"+t.sprChatSettings.appId,e.onerror=function(){t.sprChat.loaded=!1},e.onload=function(){t.sprChat.loaded=!0};var a=n.getElementsByTagName("script")[0];a.parentNode.insertBefore(e,a)};"function"==typeof e?a?e("update",t.sprChatSettings):o():"loading"!==n.readyState?o():n.addEventListener("DOMContentLoaded",o)})()
**/

/**window.sprChatSettings = window.sprChatSettings || {}; 
window.sprChatSettings = {
    "appId":"app_768933",
    "skin":"MODERN"
};  

(function(){var t=window,e=t.sprChat,a=e&&!!e.loaded,n=document,r=function(){r.m(arguments)};r.q=[],r.m=function(t){r.q.push(t)},t.sprChat=a?e:r;var e2=t.sprTeamChat,r2=function(){r2.m(arguments)};r2.q=[],r2.m=function(t){r2.q.push(t)},t.sprTeamChat=e2?e2:r2;var o=function(){var e=n.createElement("script"); e.type="text/javascript",e.async=!0,e.src="https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/"+t.sprChatSettings.appId; e.onerror=function(){t.sprChat.loaded=!1},e.onload=function(){t.sprChat.loaded=!0};var a=n.getElementsByTagName("script")[0];a.parentNode.insertBefore(e,a)};"function"==typeof e?a?e("update",t.sprChatSettings):o():"loading"!==n.readyState?o():n.addEventListener("DOMContentLoaded",o)})()
**/

//if (site == 'uk') {

var sprChatAppId =
  window.location.host == "www.samsung.com" ? "app_400790" : "app_768933";
sprChatAppId = "app_400790";
console.log("sprChatAppId -> ", sprChatAppId);

window.sprChatSettings = window.sprChatSettings || {};

window.sprChatSettings = {
  appId: sprChatAppId,

  skin: "CLASSIC",
};

(function () {
  var t = window,
    e = t.sprChat,
    a = e && !!e.loaded,
    n = document,
    r = function () {
      r.m(arguments);
    };
  (r.q = []),
    (r.m = function (t) {
      r.q.push(t);
    }),
    (t.sprChat = a ? e : r);
  var e2 = t.sprTeamChat,
    r2 = function () {
      r2.m(arguments);
    };
  (r2.q = []),
    (r2.m = function (t) {
      r2.q.push(t);
    }),
    (t.sprTeamChat = e2 ? e2 : r2);
  var o = function () {
    var e = n.createElement("script");
    (e.type = "text/javascript"),
      (e.async = !0),
      (e.src =
        "https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/" +
        t.sprChatSettings.appId);
    (e.onerror = function () {
      t.sprChat.loaded = !1;
    }),
      (e.onload = function () {
        t.sprChat.loaded = !0;
      });
    var a = n.getElementsByTagName("script")[0];
    a.parentNode.insertBefore(e, a);
  };
  "function" == typeof e
    ? a
      ? e("update", t.sprChatSettings)
      : o()
    : "loading" !== n.readyState
    ? o()
    : n.addEventListener("DOMContentLoaded", o);
})();

/**} else if(site == 'ie') {

    var sprChatAppIdIE =  (window.location.host == "www.samsung.com") ? "5eb1922fa11e8e401c9aee7c_app_449856":"5fe1bd7b86929a4bf418cc9f_app_769168";

    window.sprChatSettings = window.sprChatSettings || {}; 
    window.sprChatSettings = {"appId":sprChatAppIdIE,"skin":"MODERN"}; 

    (function(){var t=window,e=t.sprChat,a=e&&!!e.loaded,n=document,r=function(){r.m(arguments)};r.q=[],r.m=function(t){r.q.push(t)},t.sprChat=a?e:r;var e2=t.sprTeamChat,r2=function(){r2.m(arguments)};r2.q=[],r2.m=function(t){r2.q.push(t)},t.sprTeamChat=e2?e2:r2;var o=function(){var e=n.createElement("script"); e.type="text/javascript",e.async=!0,e.src="https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/"+t.sprChatSettings.appId; e.onerror=function(){t.sprChat.loaded=!1},e.onload=function(){t.sprChat.loaded=!0};var a=n.getElementsByTagName("script")[0];a.parentNode.insertBefore(e,a)};"function"==typeof e?a?e("update",t.sprChatSettings):o():"loading"!==n.readyState?o():n.addEventListener("DOMContentLoaded",o)})() 


}**/

!(function () {
  function docReady(fn) {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }
  docReady(function () {
    $('#needtocontactus .s-marketing-cta a[aria-label$="Live Chat"]').on(
      "click",
      function (e) {
        e.preventDefault();

        window.sprChat("openNewConversation");
      }
    );

    $('.confirm-message a[title$="Live Chat"]').on("click", function (e) {
      e.preventDefault();

      window.sprChat("openNewConversation");
    });

    /** Once the chat widget minimised then hide live chat widget **/
    // $("body").on("DOMSubtreeModified", "#spr-live-chat-app", function () {
    //   if ($(".spr-chat__box").length == 0) {
    //     $("#spr-live-chat-app").hide();
    //   } else {
    //     $("#spr-live-chat-app").show();
    //   }
    // });
    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    let proactiveBox = document.querySelector(".spr-chat__proactive-box");

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          const chatApp = document.getElementById("spr-live-chat-app");
          if (chatApp) {
            if ($(".spr-chat__box").length == 0) {
              chatApp.style.display = "none";
            } else {
              chatApp.style.display = "block";
              if (proactiveBox && !document.body.contains(proactiveBox)) {
                chatApp.appendChild(proactiveBox);
              }
            }
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  });
})();

!(function () {
  "use strict";
  "eg" ===
    (function (t) {
      for (
        var n, e = t + "=", o = document.cookie.split(";"), r = 0, s = o.length;
        r < s;
        r++
      ) {
        for (n = o[r]; " " === n.charAt(0); ) n = n.substring(1);
        if (-1 !== n.indexOf(e)) return n.substring(e.length, n.length);
      }
      return "";
    })("country_codes") &&
    window.location.replace(
      "https://livechat.support.samsung.com/Customer_new/EG"
    );
})();
